import * as React from 'react';
import { useNotification } from '@strapi/strapi/admin';
import { useIntl } from 'react-intl';
import { useTemplatesApi, type EmailTemplateListItem } from '../api/templates';
import { PLUGIN_ID } from '../pluginId';

export const useTemplates = () => {
  const api = useTemplatesApi();
  const { toggleNotification } = useNotification();
  const { formatMessage } = useIntl();

  const [items, setItems] = React.useState<EmailTemplateListItem[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const refresh = React.useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await api.list();
      setItems(data ?? []);
    } catch (err: any) {
      setError(err?.message ?? 'Unknown error');
      toggleNotification({
        type: 'danger',
        message: formatMessage({ id: `${PLUGIN_ID}.editor.toast.loadError`, defaultMessage: 'Failed to load templates' }),
      });
    } finally {
      setLoading(false);
    }
  }, [api, toggleNotification, formatMessage]);

  React.useEffect(() => {
    refresh();
  }, []);

  return { items, loading, error, refresh };
};
